import React from 'react';

import { ApIcon, colors, ApSecondaryNav } from '@alixpartners/ui-components';
import { useLocation, NavLink } from 'react-router-dom';
import {
	ApButtonTab,
	ApButtonMain,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import { SearchInput } from 'components/SearchInput';
import { Tooltip } from 'react-tippy';
import { CONFIG } from '../routes';
import {
	TabsWrapper,
	ControlsWrapper,
	ActionItem,
	Divider,
	SearchWrapper,
	TooltipContent,
	TooltipIcon,
} from './SecondaryNav.styles';

const getUndoTitle = () => {
	const metaKeyName =
		navigator.appVersion.indexOf('Mac') !== -1 ? '⌘Cmd' : 'Ctrl';

	return `Press ${metaKeyName}+Z to undo your last action`;
};

export const SecondaryNav = ({
	isExportDisabled,
	isUndoDisabled,
	onUndo,
	onImport,
	onExport,
	searchConfig,
}) => {
	const location = useLocation();
	const isDividerHidden = (!onImport && !onExport) || searchConfig;

	return (
		<ApSecondaryNav
			left={
				<TabsWrapper>
					{CONFIG.map(
						({ label, path, disabled, hideTab, includePath }) =>
							!hideTab ? (
								<NavLink to={path} key={path} disabled={disabled}>
									<ApButtonTab
										isSelected={
											location.pathname.includes(path) ||
											(includePath && location.pathname.includes(includePath))
										}
										disabled={disabled}
									>
										{label}
									</ApButtonTab>
								</NavLink>
							) : null
					)}
				</TabsWrapper>
			}
			right={
				<ControlsWrapper>
					{onUndo && (
						<ActionItem title={!isUndoDisabled ? getUndoTitle() : undefined}>
							<ApButtonSecondary
								iconName="undo"
								disabled={isUndoDisabled}
								onClick={() => {
									onUndo();
								}}
							>
								Undo
							</ApButtonSecondary>
						</ActionItem>
					)}

					{!isDividerHidden && <Divider />}

					{searchConfig && (
						<SearchWrapper>
							<SearchInput
								placeholder="Search..."
								placement="bottom-end"
								charCount={3}
								maxMatchesNumber={10}
								showIcon
								isSelectable
								isDismissible
								{...searchConfig}
							/>
							<TooltipIcon>
								<Tooltip
									position="bottom"
									animation="fade"
									arrow
									theme="light"
									trigger="click"
									html={
										<TooltipContent>
											Enter EVP, Budget Owner, Department, Site, Business Unit,
											Workstream or Initiative to filter the data in the charts
										</TooltipContent>
									}
									popperOptions={{
										modifiers: {
											preventOverflow: {
												enabled: true,
												boundariesElement: 'window',
											},
										},
									}}
								>
									<ApIcon
										iconName="outline_info"
										iconColor={colors.grey5}
										iconSize={16}
									/>
								</Tooltip>
							</TooltipIcon>
						</SearchWrapper>
					)}

					{onExport && (
						<ActionItem>
							<ApButtonSecondary
								disabled={isExportDisabled}
								onClick={onExport}
								iconName="download"
							>
								Export data
							</ApButtonSecondary>
						</ActionItem>
					)}
					{onImport && (
						<ActionItem>
							<ApButtonMain onClick={onImport} iconName="upload_outlined">
								Import data
							</ApButtonMain>
						</ActionItem>
					)}
				</ControlsWrapper>
			}
		/>
	);
};

export default SecondaryNav;
